import {inject, Injectable} from '@angular/core';
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {TooltipModalComponent} from "./tooltip-modal/tooltip-modal.component";

@Injectable({
  providedIn: 'root'
})
export class TooltipModalService {

  modalService = inject(NgbModal)
  openTooltipModal(tutorial: string, title = '') {
    const modalRef: NgbModalRef = this.modalService.open(TooltipModalComponent, {size: 'xl', centered: true});
    const component: TooltipModalComponent = modalRef.componentInstance;
    component.tutorial = tutorial;
    component.title = title;
  }
}
